import { render } from "./interface_language_switcher.vue?vue&type=template&id=67e827b0"
import script from "./interface_language_switcher.vue?vue&type=script&lang=js"
export * from "./interface_language_switcher.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__